import React, { useEffect, useState } from 'react';
import { Table, Space, Select } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';

interface FormItemProps {
  detailList: any[] | undefined;  
}

const CLOSINGDetailTable = ({detailList}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  const columns: ColumnsType<any> = [
    {
      title: '번호',
      dataIndex: 'group_srl',
      key: 'group_srl',
      width: '60px',
      align: 'center',
      ellipsis: true,
    },     
    {
      title: '기간',
      dataIndex: 'start_date',
      key: 'start_date',
      width: '150px',
      align: 'center',  
      render: (start_date, record) => {
        return (
          <label>{start_date}~{record.end_date}</label>
        )
      }  
    },
    {
      title: '기업명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '130px',
      align: 'center',
      ellipsis: true,
    },        
    {
      title: '프로젝트이름',
      dataIndex: 'title',
      key: 'title',
      width: 'auto',
      align: 'center',
      ellipsis: true,
    },          
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1_2',
      width: '150px',
      align: 'center',
      ellipsis: true,
    }, 
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1_2',
      width: '150x',
      align: 'center',
      ellipsis: true,
    },  
    {
      title: '강의시간',
      dataIndex: 'time_count',
      key: 'time_count',
      width: '80px',
      align: 'center',
      ellipsis: true,
    },  
    {
      title: '직전매출',
      dataIndex: 'pre_price',
      key: 'pre_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          <label>{value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>
        )
      }
    },  
    {
      title: '매출',
      dataIndex: 'sale_price',
      key: 'sale_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          <label>{value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>
        )
      }
    },                                              
  ];

  /* ======================================================
  * events
  * ====================================================== */ 

  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={detailList}
          columns={columns}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}          
        />
      </TableWrapper>  
    </Space>
  );
};

export default CLOSINGDetailTable;
